/* src/app/admin-dashboard/delivery/dispatch/dispatch.component.css */
.dd-wrap {
  padding: 16px;
}
.dd-toolbar {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 12px;
}
.dd-note {
  margin: 0;
  color: #555;
  font-size: 13px;
  max-width: 620px;
}
.dd-muted {
  color: #888;
  font-size: 12px;
}
.dd-empty {
  padding: 20px;
  text-align: center;
  color: #888;
  font-size: 13px;
}
.dd-date {
  display: flex;
  align-items: center;
  gap: 4px;
}
.dd-date-field {
  width: 160px;
}
.dd-date-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.dd-chip {
  border-radius: 12px;
  padding: 3px 9px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.dd-chip-ok {
  background: #e8f5e9;
  color: #2e7d32;
}
.dd-chip-warn {
  background: #fdf3e0;
  color: #8a6417;
}
.dd-chip-off {
  background: #f0f0f0;
  color: #888;
}
.dd-chip-bad {
  background: #fdecea;
  color: #c0392b;
}
.dd-run {
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 12px;
  overflow: hidden;
}
.dd-run-head {
  padding: 12px 14px;
  cursor: pointer;
}
.dd-run-head:hover {
  background: #f8fafc;
}
.dd-run-main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.dd-run-name {
  font-weight: 600;
  font-size: 15px;
}
.dd-run-sub {
  color: #666;
  font-size: 13px;
  margin-top: 3px;
}
.dd-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}
.dd-progress-bar {
  flex: 1 1 auto;
  height: 6px;
  background: #eef1f4;
  border-radius: 3px;
  overflow: hidden;
}
.dd-progress-fill {
  height: 100%;
  background: #2e7d32;
  border-radius: 3px;
  transition: width .3s ease;
}
.dd-progress-label {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
}
.dd-caret {
  color: #888;
}
.dd-seen {
  color: #2f6fd0;
  text-decoration: underline;
}
.dd-seen-stale {
  color: #999;
}
.dd-where {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #2e7d32;
}
.dd-stops {
  border-top: 1px solid #e3e6ea;
  background: #fbfcfd;
  padding: 8px 14px 14px;
  overflow-x: auto;
}
.dd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.dd-table th {
  text-align: left;
  color: #888;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 10px 6px;
  border-bottom: 1px solid #e3e6ea;
  white-space: nowrap;
}
.dd-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: top;
}
.dd-table tr:last-child td {
  border-bottom: none;
}
.dd-order {
  font-weight: 600;
  color: #666;
}
.dd-stop-name {
  font-weight: 500;
}
.dd-bad {
  color: #c0392b;
  font-weight: 600;
}
.dd-covering {
  color: #b26a00;
  font-weight: 600;
}
.dd-map-section {
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  background: #fff;
  padding: 10px 12px;
  margin-bottom: 12px;
}
.dd-map-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.dd-map-spacer {
  flex: 1 1 auto;
}
.dd-map-closed {
  display: none;
}
.dd-map-wrap {
  position: relative;
  margin-top: 8px;
}
.dd-map {
  height: 380px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e3e6ea;
}
.dd-base {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 500;
  padding: 7px 12px;
  border-radius: 8px;
  border: 1px solid #d5d9de;
  background: rgba(255, 255, 255, .94);
  color: #333;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.dd-legend {
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 500;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .92);
  border: 1px solid #d5d9de;
  font-size: 11px;
  color: #444;
}
.dd-legend span {
  display: flex;
  align-items: center;
  gap: 4px;
}
.dm-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  border: 1px solid #fff;
}
.dd-map-hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #777;
}
.dd-map-warn {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8a6417;
}
/*# sourceMappingURL=dispatch.component.css.map */
